module.exports = __webpack_public_path__ + "h5/img/i_nav2.a4974651.png";